const translationKeys = {
  loans_loan_section_nogi_title: 'loans_loan_section_nogi_title',
  loans_loan_section_nogi_dismiss_button:
    'loans_loan_section_nogi_dismiss_button',
  loans_loan_section_nogi_activate_button:
    'loans_loan_section_nogi_activate_button',
  loans_loan_section_nogi_cell_expired_button:
    'loans_loan_section_nogi_cell_expired_button',
  loans_nogi_consumer_loan_header_remaining_loan:
    'loans_nogi_consumer_loan_header_remaining_loan',
  loans_nogi_consumer_loan_header_of_total:
    'loans_nogi_consumer_loan_header_of_total',
  loans_nogi_consumer_loan_header_about_loan_button:
    'loans_nogi_consumer_loan_header_about_loan_button',
  loans_nogi_consumer_loan_overview_next_payment:
    'loans_nogi_consumer_loan_overview_next_payment',
  loans_nogi_consumer_loan_overview_nominal_remaining_loan_time:
    'loans_nogi_consumer_loan_overview_nominal_remaining_loan_time',
  loans_nogi_consumer_loan_overview_nominal_interest_rate:
    'loans_nogi_consumer_loan_overview_nominal_interest_rate',
  loans_nogi_consumer_loan_section_borrower_title:
    'loans_nogi_consumer_loan_section_borrower_title',
  loans_nogi_consumer_loan_information_general_remaining_loan_time:
    'loans_nogi_consumer_loan_information_general_remaining_loan_time',
  loans_nogi_consumer_loan_information_header:
    'loans_nogi_consumer_loan_information_header',
  loans_nogi_consumer_loan_information_general_remaining_debt:
    'loans_nogi_consumer_loan_information_general_remaining_debt',
  loans_nogi_consumer_loan_information_general_original_loan_amount:
    'loans_nogi_consumer_loan_information_general_original_loan_amount',
  loans_nogi_consumer_loan_information_general_title:
    'loans_nogi_consumer_loan_information_general_title',
  loans_nogi_consumer_loan_information_general_name:
    'loans_nogi_consumer_loan_information_general_name',
  loans_nogi_consumer_loan_information_conditions_monthly_fees:
    'loans_nogi_consumer_loan_information_conditions_monthly_fees',
  loans_nogi_consumer_loan_information_conditions_nominal_interest_rate:
    'loans_nogi_consumer_loan_information_conditions_nominal_interest_rate',
  loans_nogi_consumer_loan_information_conditions_payment_period:
    'loans_nogi_consumer_loan_information_conditions_payment_period',
  loans_nogi_consumer_loan_information_conditions_title:
    'loans_nogi_consumer_loan_information_conditions_title',
  loans_nogi_consumer_loan_information_conditions_descriptions:
    'loans_nogi_consumer_loan_information_conditions_descriptions',
  loans_nogi_credit_card_header_balance:
    'loans_nogi_credit_card_header_balance',
  loans_nogi_credit_card_header_information_button:
    'loans_nogi_credit_card_header_information_button',
};

Object.freeze(translationKeys);

export default translationKeys;
